import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from '../account.service';

@Component({
  selector: 'app-move-socio',
  templateUrl: './move-socio.component.html',
  styleUrls: ['./move-socio.component.scss']
})
export class MoveSocioComponent implements OnInit {
  // deux formulaires, un pour l'email, un pour le code
  emailForm!: FormGroup;
  codeForm!: FormGroup;

  // pour basculer d'une étape à l'autre
  awaitingCode = false;

  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    public dialogRef: MatDialogRef<MoveSocioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      socioId: number,
      newEmail?: string,
      accountValidationKey?: string
    },
  ) {}

  ngOnInit() {
    // init des formulaires
    this.emailForm = this.fb.group({
      email: [ this.data.newEmail || '', [ Validators.required, Validators.email ]]
    });
    this.codeForm = this.fb.group({
      code: ['', Validators.required]
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // Étape 1 : envoi de l'email — récupère validationKey
  submitEmail(): void {
    if (this.emailForm.invalid) { return; }
    const email = this.emailForm.value.email;
    this.accountService.requestSplitAccount(this.data.socioId, email)
      .subscribe({
        next: resp => {
          this.data.newEmail = email;
          this.data.accountValidationKey = resp.validationKey;
          this.awaitingCode = true;
        },
        error: err => {
          console.error(err);
          // TODO: afficher un message d'erreur à l'utilisateur
        }
      });
  }

  // Étape 2 : validation du code => fermeture du dialog
  submitCode(): void {
    if (this.codeForm.invalid) { return; }
    const code = this.codeForm.value.code;
    this.accountService.splitAccount(
      this.data.socioId,
      this.data.newEmail!,
      code
    ).subscribe({
      next: () => this.dialogRef.close({ success: true, newEmail: this.data.newEmail }),
      error: err => {
        console.error(err);
        alert("Le code saisi semble incorrect. Veuillez réessayer.");
      }
    });
  }
}
